module.exports = __webpack_public_path__ + "img/status_6.ef282731.png";